import { atsDucks } from './ducks';

const moduleContent = {
	...atsDucks,
};

export default moduleContent;
